export function VotingPrecinctTemplate(params) {
    return `<table class="esri-widget__table" summary="List of attributes and values">
          <tbody>
                <tr>
                    <img src="https://www.dmcwebgis.com/Apps/election/css/img/{id}.jpg" />
                    <hr/>
                </tr>
              <tr>
                  <th class="third">Precinct</th>
                  <td class="two-third">{Name}</td>
              </tr>
              <tr>
                  <th class="third">Polling Location</th>
                  <td class="two-third">{Polling Location}</td>
              </tr>
              <tr>
                  <th class="third">Polling Address</th>
                  <td class="two-third">{Address}</td>
              </tr>
          </tbody>
      </table>`;
  }
  